import axios from "axios";
import HashMap from "hashmap";
import { Master_Service_TEAMS_URL } from "../Url";
var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const teamSaveAllActions = {
  TEAM_SAVEALL_LOADING: "TEAM_SAVEALL_LOADING",
  TEAM_SAVEALL_SUCCESS: "TEAM_SAVEALL_SUCCESS",
  TEAM_SAVEALL_ERROR: "TEAM_SAVEALL_ERROR",
};

export const teamSaveAllDetails = (props) => {
  const { accessToken, params, values } = props;

  return (dispatch) =>
    axios({
      method: "post",
      url: `${Master_Service_TEAMS_URL}/saveAllTeamDetails`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
      data: values,
      params: params,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(teamSaveAllSuccess(response.data.dto));

          return response;
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(teamSaveAllError(error));

          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));
          dispatch(teamSaveAllError(err));
          return err;
        } else if (!err.response) {
        }
      });
};

export const teamSaveAllSuccess = (props) => {
  return {
    type: teamSaveAllActions.TEAM_SAVEALL_SUCCESS,
    payload: props,
  };
};

export const teamSaveAllError = (props) => {
  return {
    type: teamSaveAllActions.TEAM_SAVEALL_ERROR,
    payload: props,
  };
};

export const teamSaveAllLoading = () => {
  return {
    type: teamSaveAllActions.TEAM_SAVEALL_LOADING,
  };
};
